import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React, { useContext } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { MdCheck, MdFileCopy, MdHighlightOff, MdInfoOutline } from "react-icons/md";
import { ClientContext } from "ClientProvider";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

const SettlementDetails = ({ info }: { info?: any; }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const { singleRoleData } = useContext(ClientContext);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };


  return (
    <>
    <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
        <PopoverTrigger>
        <button className="fp-info-trigger" onClick={onOpen} aria-label="View Settlement Details " onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}>
            <MdInfoOutline size={14} />
        </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="220px" p="0" overflow="hidden" zIndex="20">
        <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="14px" py="10px">
            View Settlement Details 
        </PopoverHeader>
        <PopoverArrow bg="#eff6ff" />
        </PopoverContent>
    </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`fp-panel${isOpen && !isCloseModal ? " fp-panel--open" : " fp-panel--close"}`}>
            <div className="fp-panel-glow" />

            <div className="fp-panel-header">
                <div className="fp-panel-brand">
                <div className="fp-panel-logo">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                </div>
                <div>
                    <h2 className="fp-panel-title">Settlement Details</h2>
                    <p className="fp-panel-sub">Detailed of configured settlement</p>
                </div>
                </div>
                <button className="fp-panel-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
            </div>

            <div className="fp-panel-body">

                <div className="fp-card">
                    <div className="fp-card-title">
                        Settlement Configuration
                    </div>
                    <div className="fp-grid">
                        <div className="fp-item">
                            <div className="fp-label">Organization</div>
                            <div className="fp-value">
                                {info.organization_name}
                            </div>
                        </div>
                        <div className="fp-item">
                            <div className="fp-label">Settlement Currency</div>
                            <div className="fp-value">
                                {info.settlement_details?.settlement_currency}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fp-card">
                    <div className="fp-card-title">
                        Clients
                    </div>
                    <div className="fp-badge-wrap">
                        {info?.clients?.map((item:any)=>(
                            <span
                                key={item.name}
                                className="fp-badge fp-badge-green"
                            >
                                👤 {item.name}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="fp-card">
                    <div className="fp-card-title">
                        Payment Methods
                    </div>
                    <div className="fp-badge-wrap">
                        {info.settlement_details?.payment_methods?.map((item:any)=>(
                            <span
                                key={item.name}
                                className="fp-badge fp-badge-green"
                            >
                                💳 {item.name}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="fp-card">
                    <div className="fp-card-title">
                        Schedule Configuration
                    </div>
                    <div className="fp-grid">
                        <div className="fp-item">
                            <div className="fp-label">
                                Schedule Type
                            </div>
                            <div className="fp-value capitalize">
                                {info.schedule_type}
                            </div>
                        </div>
                        <div className="fp-item">
                            <div className="fp-label">
                                Execution Time
                            </div>
                            <div className="fp-value">
                                {info.execution_time}
                            </div>
                        </div>
                        {info.schedule_type === "weekly" && (
                            <div className="fp-item">
                                <div className="fp-label">
                                    Day of Week
                                </div>
                                <div className="fp-value">
                                    {info.execution_day}
                                </div>
                            </div>
                        )}
                        {info.schedule_type === "monthly" && (
                            <div className="fp-item">
                                <div className="fp-label">
                                    Day of Month
                                </div>
                                <div className="fp-value">
                                    {info.execution_day || "End of Month"}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="fp-card">
                    <div className="fp-card-title">
                        Statistics
                    </div>
                    <div className="fp-grid">
                        <div className="fp-item">
                            <div className="fp-label">
                                Status
                            </div>
                            <span
                                className={`fp-badge ${
                                    info.status === "Active"
                                        ? "fp-badge-green"
                                        : "fp-badge-purple"
                                }`}
                            >
                                {info.status}
                            </span>
                        </div>
                        <div className="fp-item">
                            <div className="fp-label">
                                Total Generated
                            </div>
                            <div className="fp-value">
                                {info.total_settlement_generated}
                            </div>
                        </div>
                        <div className="fp-item">
                            <div className="fp-label">
                                Created At
                            </div>
                            <div className="fp-value">
                                {info.created_at.replace("GMT","")}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="fp-panel-footer">
                <div className="fp-footer-note">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    Read-only settlement scheduled details
                </div>
                <button className="fp-btn-close" onClick={handleClose}>Close</button>
            </div>
        </div>
      </Modal>

        {FP_PANEL_STYLES}
    </>
  );
};

export default SettlementDetails;

/* ── Shared panel styles for all FiatPayout info panels ── */
export const FP_PANEL_STYLES = (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    .fp-card{
        background:#fff;
        border:1px solid #e2e8f0;
        border-radius:14px;
        padding:18px;
    }

    .fp-card-title{
        font-size:14px;
        font-weight:700;
        color:#0f172a;
        margin-bottom:16px;
    }

    .fp-grid{
        display:grid;
        grid-template-columns:repeat(2,minmax(0,1fr));
        gap:18px;
    }

    .fp-item{
        display:flex;
        flex-direction:column;
        gap:4px;
    }

    .fp-label{
        font-size:12px;
        font-weight:600;
        color:#64748b;
    }

    .fp-value{
        font-size:14px;
        font-weight:700;
        color:#0f172a;
        word-break:break-all;
    }

    .fp-badge-wrap{
        display:flex;
        flex-wrap:wrap;
        gap:10px;
    }

    .fp-badge{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        padding:7px 14px;
        border-radius:999px;
        font-size:12px;
        font-weight:700;
    }

    .fp-badge-blue{
        background:#eff6ff;
        border:1px solid #bfdbfe;
        color:#2563eb;
    }

    .fp-badge-green{
        background:#f0fdf4;
        border:1px solid #bbf7d0;
        color:#15803d;
    }

    .fp-badge-purple{
        background:#faf5ff;
        border:1px solid #ddd6fe;
        color:#7c3aed;
    }

    .fp-empty-value{
        color:#94a3b8;
        font-size:13px;
        font-weight:600;
    }

    @media(max-width:700px){

        .fp-grid{
            grid-template-columns:1fr;
        }

    }
    .fp-info-trigger {
      width: 28px; height: 28px; border-radius: 7px; background: #f8fafc;
      border: 1.5px solid #e2e8f0; color: #64748b;
      display: flex; align-items: center; justify-content: center;
      transition: all .15s; cursor: pointer;
    }
    .fp-info-trigger:hover { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
    .fp-info-trigger:disabled { opacity: .45; cursor: not-allowed; }

    .fp-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:640px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
    .fp-panel--open  { transform:translateX(0); }
    .fp-panel--close { transform:translateX(100%); }

    .fp-panel-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#0f2744,#2563eb,#7c3aed,#2563eb,#0f2744); background-size:200% 100%; animation:fpGlow 3s linear infinite; }
    @keyframes fpGlow { 0%{background-position:0%} 100%{background-position:200%} }

    .fp-panel-header { padding:15px 26px; background:linear-gradient(135deg,#0f2744 0%,#1a3d6b 60%,#1d4ed8 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
    .fp-panel-brand { display:flex; align-items:center; gap:13px; }
    .fp-panel-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
    .fp-panel-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
    .fp-panel-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
    .fp-panel-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
    .fp-panel-close:hover { color:#fff; }

    .fp-panel-body { flex:1; overflow-y:auto; background:#f8fafc; padding:20px 24px; display:flex; flex-direction:column; gap:16px; }
    .fp-panel-body::-webkit-scrollbar { width:4px; }
    .fp-panel-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

    /* Tab bar (shared) */
    .fp-tab-bar { display:flex; border-bottom:1.5px solid #e2e8f0; background:#fafbfc; flex-shrink:0; padding:0 24px; }
    .fp-tab { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:14px 16px; border:none; background:none; border-bottom:2.5px solid transparent; cursor:pointer; transition:all .18s; margin-bottom:-1.5px; }
    .fp-tab:hover { color:#1d4ed8; }
    .fp-tab--active { color:#1d4ed8; border-bottom-color:#2563eb; font-weight:700; }

    /* JSON block */
    .fp-json-section { background:#fff; border:1px solid #e2e8f0; border-radius:14px; overflow:hidden; }
    .fp-json-header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; background:#f8fafc; border-bottom:1px solid #f1f5f9; }
    .fp-json-label { display:flex; align-items:center; gap:8px; font-size:12px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
    .fp-json-dot { width:8px; height:8px; border-radius:50%; flex-shrink:0; }
    .fp-json-dot--blue  { background:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.15); }
    .fp-json-dot--green { background:#16a34a; box-shadow:0 0 0 3px rgba(22,163,74,.15); }
    .fp-json-dot--purple{ background:#7c3aed; box-shadow:0 0 0 3px rgba(124,58,237,.15); }
    .fp-copy-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:600; color:#64748b; padding:5px 12px; border-radius:7px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
    .fp-copy-btn:hover { background:#f1f5f9; }
    .fp-copy-btn--copied { color:#15803d; border-color:#bbf7d0; background:#f0fdf4; }
    .fp-json-wrap { overflow:auto; max-height:500px; }
    .fp-json-wrap::-webkit-scrollbar { width:4px; height:4px; }
    .fp-json-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
    .fp-json-pre { margin:0; padding:16px 18px; font-family:'JetBrains Mono','Courier New',monospace; font-size:12.5px; line-height:1.65; color:#1e293b; white-space:pre; background:#fff; }

    /* Empty */
    .fp-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
    .fp-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
    .fp-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
    .fp-empty-desc { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }

    /* Footer */
    .fp-panel-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
    .fp-footer-note { display:flex; align-items:center; gap:6px; font-size:12px; color:#94a3b8; font-weight:500; }
    .fp-btn-close { font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:600; color:#64748b; padding:10px 24px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
    .fp-btn-close:hover { background:#f1f5f9; }

    @media (max-width:520px) { .fp-panel { max-width:100%; } .fp-panel-header { padding:16px 18px; } .fp-panel-body { padding:16px; } }
  `}</style>
);